module.exports = __webpack_public_path__ + "img/button_2.4fc430e4.jpg";